import { Scout } from "./model/scout";

/** What each host warning means, as the scout team documented the device-side rules. Shown as tooltips. */
export const HOST_WARNING_EXPLANATIONS: Record<string, string> = {
  physical: "The Pi is short of memory: under 200 MB available.",
  heap: "The JVM heap is too small for what Scout holds: over 5 % of the time goes to garbage collection.",
  undervoltage: "The power supply or cable cannot deliver 5 V, now or since boot.",
  throttled: "CPU speed capped by the firmware, now or since boot.",
  hot: "SoC at the temperature limit: over 80 °C, or the firmware's throttle bit.",
  overloaded: "More runnable threads than cores for a minute; also fires on SD card stalls.",
};

export const explainHostWarning = (warning: string) =>
  HOST_WARNING_EXPLANATIONS[warning] ?? "Reported by the device; this warning has no description yet.";

/** Explanations of the host numbers, shown as tooltips on the device page. */
export const HOST_METRIC_EXPLANATIONS = {
  temperature: "SoC temperature. The firmware throttles the CPU from 80 °C.",
  memAvailableMb: "Memory the Pi can still hand out (MemAvailable).",
  rssMb: "Resident size of the Scout process.",
  gcPausePercent: "Share of time the JVM was paused for garbage collection. High means the heap is too small.",
  load: "One-minute load average, read against the number of cores.",
};

export const hostWarnings = (scout: Scout): string[] => scout.status.host?.warnings ?? [];
